import React from 'react';
import './App.css';
import Iframe from 'react-iframe'


export default class App extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      height: 0,
      width: 0,
    }

  }

  componentDidMount() {

    let ios = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (ios) {
      console.log('ios');
      window.location.href="https://app1.opexlogistics.co.uk";
    } else {
      console.log('not ios')
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("orientationchange", this.updateWindowDimensions);
  }
  updateWindowDimensions = () => {
    this.setState({ height: window.innerHeight, width: window.innerWidth });

  }


  render() {

    return (
      <div className="App">
          <Iframe 
          url="https://app1.opexlogistics.co.uk"
          width={this.state.width}
          height={this.state.height}
          id="myId"
          className={"iFrameClass"}
          //display="initial"
          position="fixed"/>
          
        
      </div>
    );
  }
  
}

